@let entry = inspectionEntry();
<div class="inspection-entry-form">
  <hau-form [formGroup]="entry">
      <hau-form-field label="Feststellung" [validation]="entry.validation.predefinedAssessment">
        <wr-assessment-preset-select [checkpointId]="entry.controls.checkpointId.value"
                                     [formControl]="entry.controls.predefinedAssessment">
        </wr-assessment-preset-select>
      </hau-form-field>
      <hau-form-field label="Maßnahme" [validation]="entry.validation.action" cols="6">
        <wr-action-select [formControl]="entry.controls.action"
                          [tenantId]="creatorTenantId()"
                          [recommendedValue]="recommendedAction()">
        </wr-action-select>
      </hau-form-field>
      <hau-form-field label="Frist" [validation]="entry.validation.deadline" cols="6">
        <wr-deadline-select [formControl]="entry.controls.deadline"
                            [recommendedValue]="recommendedDeadline()">
        </wr-deadline-select>
      </hau-form-field>
      <hau-form-field label="Beschreibung" [validation]="entry.validation.note" cols="12">
        @if (enabled() && textBlocks().length) {
          <button hauSuffix
                  nbButton
                  ghost
                  size="small"
                  type="button"
                  title="Textbaustein einfügen"
                  data-cy="insert-text-block-button"
                  (click)="insertTextBlock()">
            <nb-icon pack="eva" icon="file-add-outline"></nb-icon>
          </button>
        }
        <textarea fullWidth nbInput data-cy="entry-note-textarea" [formControl]="entry.controls.note"></textarea>
      </hau-form-field>
      @if (usesRiskAssessment()) {
        <hau-form-field label="Eintrittswahrscheinlichkeit" cols="12">
          <nb-radio-group class="risk-radio-group" name="occurrenceProbability" [formControl]="entry.controls.occurrenceProbability">
            @for (option of riskLevelOptions; track option.value) {
              <nb-radio [value]="option.value">{{ option.label }}</nb-radio>
            }
          </nb-radio-group>
        </hau-form-field>
        <hau-form-field label="Schadensausmaß" cols="12">
          <nb-radio-group class="risk-radio-group" name="damageExtent" [formControl]="entry.controls.damageExtent">
            @for (option of riskLevelOptions; track option.value) {
              <nb-radio [value]="option.value">{{ option.label }}</nb-radio>
            }
          </nb-radio-group>
        </hau-form-field>
      }
      <hau-form-field label="Bilder & Dokumentenliste" [validation]="entry.validation.attachments">
        <wr-multi-attachment-control
          [formControl]="entry.controls.attachments"></wr-multi-attachment-control>
      </hau-form-field>
      <hau-form-field label="TGA" [validation]="entry.validation.buildingEquipments" cols="12">
        <wr-building-equipment-multi-select [formControl]="entry.controls.buildingEquipments"
                                            [building]="building()"
                                            [buildingSection]="buildingSection()"></wr-building-equipment-multi-select>
      </hau-form-field>
      <hau-form-field label="Kommentare" cols="12">
        <wr-comments [formGroup]="entry"></wr-comments>
      </hau-form-field>
  </hau-form>
</div>
